import { PaletteOptions, SimplePaletteColorOptions, TypeText } from '@mui/material';


interface ExtendedPaletteColorOptions extends SimplePaletteColorOptions
{
	lighter?: string
	darker?: string
}


interface ExtendedPaletteOptions extends PaletteOptions
{
	primary: ExtendedPaletteColorOptions
	secondary: ExtendedPaletteColorOptions
	slate:  Partial<Record<string, any>>
	navy:  Partial<Record<string, any>>
	teal:  Partial<Record<string, any>>
	red:   Partial<Record<string, any>>
	text?: Partial<TypeText>
	error?: ExtendedPaletteColorOptions
	warning?: ExtendedPaletteColorOptions
	info?: ExtendedPaletteColorOptions
	success?: ExtendedPaletteColorOptions
	// And your custom palette options if you defined them, e.g:
	// brand: ExtendedPaletteColorOptions
}

export const pu_secondary_color = '#1b6378';

/** Light blue background used for informational panels */
export const info_bg_light = '#e8f0fe';

/** Brand gradients for consistent styling across the application */
export const gradients = {
	/** Primary brand gradient used for dialog headers and prominent UI elements */
	primaryHeader: 'linear-gradient(90deg, #1b6378 0%, #1b8aa0 100%)'
} as const;

/**
 * Brand navy scale. Extracted so `primary` can reference it — the two must stay in step.
 */
const navy = {
	[900]: '#0E333E',
	[700]: '#1B6378',
	[500]: '#3288A1',
	[300]: '#86C5D8',
	[100]: '#D4EFF8'
};

export const palette: ExtendedPaletteOptions =
{
	// Primary is the brand navy, so MUI's `contained` buttons match the pu_primary variant
	// (navy[700] fill, navy[900] hover) instead of rendering in indigo.
	primary: {
		lighter: navy[300],
		light: navy[500],
		main: navy[700],
		dark: navy[900],
		contrastText: '#fff'
	},
	secondary: {
		lighter: '#ffb74d',
		light: '#ff7961',
		main: '#f98b00',
		dark: '#9f0000',
		darker: '#870000',
		contrastText: '#000'
	},
	slate: {
		[900]: '#313D42',
		[700]: '#576C75',
		[500]: '#8FA3AC',
		[300]: '#CAD5DA',
		[100]: '#F1F4F5'
	},
	navy: navy,
	teal: {
		[900]: '#1B342C',
		[700]: '#458E77',
		[500]: '#71C6AC',
		[300]: '#A8DDCB',
		[100]: '#E6F5F0'
	},
	red: {
		[700]: '#B71C1C',
		[500]: '#D32F2F',
		[300]: '#EF5350',
		[100]: '#ffcdd2'
	}
	// text,
	// error,
	// warning,
	// info,
	// success,
};
